import Vue from 'vue'

Vue.mixin({
  methods: {
    formatCpfCNPJString (data) {
      if (data.length < 11) {
        var sizeCPF = 11
        var doccpf = ''
        for (var i = 0; i < sizeCPF - data.length; i++) {
          doccpf = doccpf + '0'
        }
        return doccpf + data
      } else if (data.length > 11 && data.length < 14) {
        var sizeCNPJ = 14
        var doccpnj = ''
        for (var j = 0; j < sizeCNPJ - data.length; j++) {
          doccpnj = doccpnj + '0'
        }
        return doccpnj + data
      } else {
        return data
      }
    }
  }
})
